module.exports = __webpack_public_path__ + "pic/35.5a5a6e74.png";